import { Component, OnDestroy, OnInit } from '@angular/core';
import { QualService } from '../service/qual.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-interview-invite',
  templateUrl: './interview-invite.component.html',
  styleUrls: ['./interview-invite.component.scss']
})
export class InterviewInviteComponent implements OnInit, OnDestroy {
  public isCommaSapratedMails: boolean;
  constructor(public QService:QualService,private notifier:NotifierService) { }

  ngOnInit(): void {
    this.QService.inviteList = [];
  }

  ngOnDestroy(){
    this.close();
    this.QService.interviewUuid = '';
    this.QService.inviteList = [];
    this.QService.invitingEmails = [];
    this.QService.showSuggestion = false;
    this.QService.suggestedEmails = '';
  }

  onSubmit(){
    this.QService.invitingEmails;
    let body = {"email":this.QService.invitingEmails,"uuid":this.QService.interviewUuid,"type":"interview"};
    console.log("body are ===>> ",body);
    this.QService.inviteUser(body).subscribe(result =>{
      if (result['status'] == 1) {
        this.QService.getInterviewList();
        this.notifier.notify('success',result['message']);
        this.close(); 
      }else{
        this.notifier.notify('error',result['message']);
      }
    });
  }

  close(){
    this.QService.interviewUuid = '';
    this.QService.isOpenInvite = false;
    this.QService.inviteList = [];
    this.QService.invitingEmails = [];
    this.QService.showSuggestion = false;
    this.QService.suggestedEmails = '';
  }

  deleteSelects(email){
    let index = this.QService.invitingEmails.indexOf(email);
    this.QService.invitingEmails.splice(index,1);
  }

  validateCurrentEmail(e){
    this.isCommaSapratedMails = e.target.value.includes(',') ? true : false;
    if (this.isCommaSapratedMails) {
      this.QService.showSuggestion = false;
    }else{
      let trimmedStr = this.removeExtraSpaces(e.target.value);
      if(this.validateEmail(trimmedStr)){
        this.QService.showSuggestion = true;
      } 
      else{
        this.QService.showSuggestion = false;
      }
    }
  }
  selectCommaSapratedMails(){
    if (this.isCommaSapratedMails) {
      let invalidMails = ""
      let mailList = this.QService.suggestedEmails.split(',');
      mailList.forEach(mail => {
        let trimmedStr = this.removeExtraSpaces(mail);
        if (!this.QService.invitingEmails.includes(trimmedStr)) {
          if(this.validateEmail(trimmedStr)){
            this.QService.invitingEmails.push(trimmedStr);
          }else{
            if (invalidMails == "") {
              invalidMails = invalidMails + trimmedStr;
            }else{
              invalidMails = invalidMails + ',' + trimmedStr;
            }
          }
        }
      });
      this.QService.suggestedEmails = invalidMails;
    }
  }

  saveCurrentEmail(){
    if(this.QService.showSuggestion){
      this.selectSuggestion();
    }
  }

  selectSuggestion(){
    this.QService.invitingEmails.push(this.QService.suggestedEmails);
    this.QService.showSuggestion = false;
    this.QService.suggestedEmails = '';
  }

  removeExtraSpaces(str){
    return str.replace(/^[ ]+|[ ]+$/g,'');
  }

  validateEmail =(eml)=> /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(eml);
}
